module.exports = __webpack_public_path__ + "components/country-flag/static/ki-7c0c48e75bf55a3a43380f8d017f4909.svg";